import executeRequest from "Infrastructure/WebClient";
import * as RequestTypes from "Application/RequestTypes";
import { PaymentPlan } from "Domain/PaymentPlan/Entity/PaymentPlan";

export async function getPayment(id: string) {
  return executeRequest<PaymentPlan>(RequestTypes.PAYMENT_DETAILS, [], {
    id: id,
  }).then((res) => {
    return res;
  });
}

export async function getCreditorPayment(id: string) {
  return executeRequest<PaymentPlan>(
    RequestTypes.CREDITOR_PAYMENT_DETAILS,
    [],
    {
      id: id,
    }
  ).then((res) => {
    return res;
  });
}

export async function markPaymentAsPayed(id: string) {
  return executeRequest<PaymentPlan>(RequestTypes.PAYMENT_MARK_AS_PAYED, [], {
    id: id,
  }).then((res) => {
    return res;
  });
}
